import { Vue } from 'nuxt-property-decorator'
import AccrualList from '@pp-frontend/shared-packages/classes/AccrualList'
import PayerAbstract from '@pp-frontend/shared-packages/classes/payer/PayerAbstract'
import { AxiosResponse } from 'axios'

/**
 * Класс логики посадок
 */
export default abstract class LandingAbstract extends Vue {
  /** @member {AccrualList} accrualList - список начислений */
  accrualList: AccrualList = new AccrualList()
  /** @member {PayerAbstract} payer - задает пользователя */
  payer!: PayerAbstract
  type!: 'fssp' | 'gibdd' | 'fns'
  /** @member {string} leadSourceId - откуда пользователь пришел */
  leadSourceId: string = 'site_search'

  /**
   * Получаем список задолженностей (пользователя, при необходимости)
   *
   * @returns {Promise<*>} promise
   */
  abstract getData (): Promise<AxiosResponse>

  userQuery (): Record<string, any> {
    return {}
  }

  /**
   * Переход к странице оплаты
   *
   * @returns {Promise<*>} promise
   */
  onPayClick (): Promise<any> {
    return window.$nuxt.$router.push({
      name: 'payment',
      query: {
        ...this.payer.getPayer(),
        payment_type: this.type,
        // @ts-ignore
        uin: this.accrualList.getMarkToPayAccruals(),
        lead_source_id: window.$nuxt.$route.query.lead_source_id as string || this.leadSourceId,
        ...this.userQuery()
      }
    })
  }
}
